import { useQuery } from '@apollo/client/react';

import { GetOnlineEncouterDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchEncounter = (sessionId: string) => {
  const { data, loading: isInitializing } = useQuery(GetOnlineEncouterDocument, {
    variables: { encounterId: sessionId },
  });
  const encounter = getNode(data, 'Encounter');

  return {
    isInitializing,
    encounter,
  };
};
